module.exports = __webpack_public_path__ + "img/red.87c7a1b0.png";